import getOffer from "./getOffer";
import stopOffer from "./stopOffer";
import startOffer from "./startOffer";
import deleteOffer from "./deleteOffer";

export default { getOffer, stopOffer, startOffer, deleteOffer };
